import classNames from 'classnames';
import React, { ReactNode } from 'react';

import css from './BooksTextButton.module.scss';

interface Props {
  onClick?: () => void;
  value?: string;
  children: ReactNode;
}

const BooksTextButton = ({ children, onClick, value }: Props) => {
  const classes = classNames(css.BooksTextButton);

  return (
    <button className={classes} onClick={onClick} value={value}>
      {children}
    </button>
  );
};

export default BooksTextButton;
